var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000;}\r\n\t.st1{fill:#000;stroke:#333333;stroke-width:32;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.04,230.91c38.48,0,68.34-43.38,68.34-80.69c0-18.24-7.21-35.03-20.31-47.27     c-12.69-11.86-29.75-18.39-48.02-18.39c-18.27,0-35.33,6.53-48.02,18.39c-13.1,12.24-20.31,29.02-20.31,47.27     C93.7,187.53,123.55,230.91,162.04,230.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.96,230.91c38.48,0,68.34-43.38,68.34-80.69c0-18.24-7.21-35.03-20.31-47.27     c-12.69-11.86-29.75-18.39-48.02-18.39s-35.33,6.53-48.02,18.39c-13.1,12.24-20.31,29.02-20.31,47.27     C281.63,187.53,311.48,230.91,349.96,230.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.01,284.21c-6.11-5.47-13.13-10.27-20.73-14.26c-3.95-2.08-8.05-3.94-12.26-5.59     c-18.7,11.29-39.59,17.37-60.98,17.37c-21.39,0-42.27-6.08-60.97-17.37c-4.22,1.65-8.31,3.51-12.27,5.59     c-16.82,8.83-30.75,21.62-38.4,36.76c-8.44,16.69-9.03,35.37-6.92,53.36c2.63,22.45,6.35,45.4,12.24,67.37h212.65     c5.89-21.97,9.6-44.92,12.23-67.37c2.11-17.99,1.52-36.67-6.92-53.36C269.49,298.42,263.41,290.83,256.01,284.21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461.61,306.71c-7.65-15.14-21.57-27.93-38.4-36.76c-3.96-2.08-8.05-3.94-12.27-5.59     c-18.7,11.29-39.58,17.37-60.97,17.37s-42.28-6.08-60.98-17.37c-1.76,0.69-3.5,1.42-5.22,2.19c7.61,7.87,13.8,16.5,18.47,25.73     c10.12,20.01,13.44,43.41,10.14,71.52c-2.81,23.96-6.41,44.88-10.99,63.64H456.3c5.88-21.97,9.6-44.92,12.22-67.37     C470.64,342.08,470.05,323.4,461.61,306.71z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.060108277b367d937e3247285516cf84.svg";
export { ForwardRef as ReactComponent };